import React from 'react'
import PropTypes from 'prop-types'
import Accordion from 'react-bootstrap/Accordion';
import cn from 'classnames'
import ExpandableHeader from './ExpandableHeader'

import './style.scss'

export const Expandable = props => {
  const {
    title,
    children,
    headerIcon,
    defaultActiveKey,
    contentClassName,
    className
  } = props

  return (
    <div className={cn('expandable', className)}>
      <Accordion defaultActiveKey={defaultActiveKey} alwaysOpen>
        <div>
          <ExpandableHeader eventKey="0">{typeof title === 'function' ? title() : title}</ExpandableHeader>
          <Accordion.Collapse className={contentClassName} eventKey="0" style={{ position: 'relative' }}>
            <div>{children}</div>
          </Accordion.Collapse>
        </div>
      </Accordion>
    </div>
  )
}

Expandable.propTypes = {
  children: PropTypes.node,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.node]),
  headerIcon: PropTypes.node,
  defaultActiveKey: PropTypes.oneOf(['1', '0']),
  contentClassName: PropTypes.string,
  className: PropTypes.string
}

Expandable.defaultProps = {
  children: null,
  title: '',
  headerIcon: null,
  defaultActiveKey: '0',
  className: ''
}
